<mat-card appearance="outlined" telemetry="Card-UserDefinedFields">

    <mat-card-header fxLayout="row" fxLayoutAlign="space-between start">
        <mat-card-title>
            User Defined Fields
        </mat-card-title>
        <user-defined-field-menu *ngIf="isLoaded && !viewOnly" [fields]="fields" (addNewField)="onAddNewField($event)">
        </user-defined-field-menu>
    </mat-card-header>

    <mat-card-content>
        <mat-progress-bar *ngIf="!isLoaded" mode="indeterminate"></mat-progress-bar>

        <ng-container *ngIf="isLoaded">
            <div *ngIf="!fields" fxLayout="column">
                <div class="emptyIcon iconCircle">
                    <mat-icon class="emptyIconContainer" fontIcon="note">
                    </mat-icon>
                    <span><b>No fields yet</b></span>
                </div>
            </div>

            <div *ngIf="fields" fxLayout="row wrap" fxLayoutAlign="space-between start">
                <ng-container *ngFor="let field of fields">
                    <user-defined-field *ngIf="field.Active" fxFlex.gt-md="25" fxFlex.md="33" fxFlex="50" [field]="field" [viewOnly]="viewOnly">
                    </user-defined-field>
                </ng-container>
            </div>

            <div *ngIf="errorMessage">
                {{errorMessage}}
            </div>
        </ng-container>

    </mat-card-content>

    <mat-card-actions>
        <command-bar [commands]="commands">
        </command-bar>
    </mat-card-actions>
</mat-card>